import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import Triangle from '../Triangle/Triangle';
import Background from '../../../components/Background/Background';
import ThemeToggle from './ThemeToggle/ThemeToggle';
import classes from './TrianglePreview.styles.less';
export default function TrianglePreview({ values, theme, onThemeToggle }) {
    return (_jsxs(Background, { className: cx(classes.wrapper, classes[theme]), children: [_jsx(ThemeToggle, { className: classes.themeToggle, theme: theme, onToggle: onThemeToggle, label: "preview" }), _jsx("div", { className: classes.triangle, children: _jsx(Triangle, { ...values }) })] }));
}
